export default __webpack_public_path__ + "dd5ddd63df2c743fef9852a5ea5a9ee0.png";